export class SetA2HSAcknowledged {
  static readonly type =
    "[Add to Home Screen] Set Add to Home Screen Acknowledged";
}
